import { useCallback } from 'react';
import { useNotificationsStore } from '@shared/services/notifications/notifications.store';
import type { ToastItem } from '@shared/services/notifications/notifications.store';

export interface SuperToastStackViewModel {
  toasts: ToastItem[];
  dismiss: (id: string) => void;
}

export function useSuperToastStack(): SuperToastStackViewModel {
  const toasts = useNotificationsStore((s) => s.toasts);
  const dismissFn = useNotificationsStore((s) => s.dismiss);
  const dismiss = useCallback((id: string) => dismissFn(id), [dismissFn]);
  return { toasts, dismiss };
}
